import React from 'react';
import { CheckIcon } from 'lucide-react';
import { summaryRows } from '../data/summary';
import { price, productShortName, totalBonuses, totalVolumes } from '../data/offer';
export function SummaryTable() {
  return <section className="bg-stone-50 py-16 sm:py-20" aria-labelledby="summary-title" data-id="element-227" data-mp="o71jkm7hsj9a">
      <div className="mx-auto max-w-4xl px-4" data-id="element-228" data-mp="j7yex2vfcf1u">
        <h2 id="summary-title" className="text-center text-3xl font-extrabold text-emerald-950 sm:text-4xl" data-id="element-229" data-mp="j53uvcgbow8y">
          Todo lo que incluye:
        </h2>
        <p className="mt-3 text-center text-stone-700" data-id="element-230" data-mp="1bwvv90g2s1ry">
          {productShortName} · {totalVolumes} tomos + {totalBonuses} bonos · <b className="text-emerald-900" data-id="element-231" data-mp="16v6j1hh49i2a">{price}</b>
        </p>

        <ul className="mt-10 grid gap-x-8 rounded-xl border border-stone-200 bg-white p-6 shadow-sm shadow-stone-900/5 sm:grid-cols-2 sm:p-8" data-id="element-232" data-mp="12vxoiae95g5o">
          {summaryRows.map(feature => <li key={feature} className="flex items-start gap-3 border-b border-stone-100 py-3 text-sm font-semibold text-emerald-950" data-id="element-233" data-mp="3nln5ou2fhe1j">
              <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-emerald-800" data-id="element-234" data-mp="3ie7jiw0tfcdd">
                <CheckIcon className="h-3.5 w-3.5 text-amber-300" aria-hidden="true" data-id="element-235" data-mp="3nb7of3lxi92w" />
              </span>
              {feature}
            </li>)}
        </ul>

        <blockquote className="mx-auto mt-10 max-w-2xl rounded-xl border-l-4 border-amber-500 bg-stone-800 px-6 py-5 text-center font-serif text-lg font-bold leading-relaxed text-stone-50" data-id="element-236" data-mp="3dcruytzfinq8">
          “El mejor momento para tener este material era al inicio del año. El segundo mejor momento es hoy.”
        </blockquote>
      </div>
    </section>;
}